import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-client"
import { ApolloLink } from "apollo-link";
import { withClientState } from 'apollo-link-state';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from "apollo-link-context";
import { InMemoryCache } from 'apollo-cache-inmemory';
import { unregister } from './registerServiceWorker';

import App from './App.js'
import './fa';
import './style.css';

const NODE_ENV = process.env.NODE_ENV || 'development';
const endpoint = NODE_ENV==='production' ? 'https://trashnet.de:3001/graphql' : 'http://localhost:3001/graphql'; //@TODO .env or sth

const httpLink = new createHttpLink({ 
	uri: endpoint
});

const authLink = setContext((request, previousContext) => {
	const token = localStorage.getItem('token');
	const headers = token ? {authorization: `Bearer ${token}`} : undefined;
	return { headers };
});

/*const errorLink = onError(({ networkError, graphQLErrors }) => {
	if (graphQLErrors) {
		graphQLErrors.map(({ message, locations, path }) =>
			console.log(`[QWERTY]: Message: ${message}, Location: ${locations}, Path: ${path}`)
		);
	}
	if (networkError) console.log(`[Network error]: ${networkError}`);
});*/

const cache = new InMemoryCache();
const stateLink = withClientState({
	cache,
	defaults: {
		clientCredentials: {
			__typename: 'credentials',
			id: null,
			name: 'anonymous',
			avatar: 'vimeo.jpg'
		}
	}/*,
	resolvers: {
		Query: () => ({})
	}*/
});

const client = new ApolloClient({
	link: ApolloLink.from([stateLink, authLink, httpLink]),
	cache: cache
});
render(<ApolloProvider client={client}>
			<Router>
				<App />
			</Router>
		</ApolloProvider>, document.getElementById("root"));

if(NODE_ENV==='production') {
	//registerServiceWorker();
	unregister();
}


// WEBPACK FOOTER //
// ./src/index.js